import React from 'react';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { DialogActions } from '@mui/material';
import { Button, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';

function DatePickerActionBar(props: PickersActionBarProps) {
  const { actions, onClear, onSetToday, ...other } = props;
  const { t } = useTranslation('components');

  const buttons = actions?.map((actionType) => {
    switch (actionType) {
      case 'clear':
        return (
          <Button type='link' onClick={onClear} key={actionType}>
            {t('datePickerActionBar.clear')}
          </Button>
        );

      case 'today':
        return (
          <Button type='link' onClick={onSetToday} key={actionType}>
            {t('datePickerActionBar.today')}
          </Button>
        );

      default:
        return null;
    }
  });

  return (
    <DialogActions {...other} sx={{ marginBottom: Theme.Spacing.mdSpacing }}>{buttons}</DialogActions>
  );
}

export default DatePickerActionBar;
